import { render } from "./verify-email-failed.vue?vue&type=template&id=38a427d6&ts=true"
import script from "./verify-email-failed.vue?vue&type=script&lang=ts"
export * from "./verify-email-failed.vue?vue&type=script&lang=ts"

import "./verify-email-failed.vue?vue&type=style&index=0&id=38a427d6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__